import { useLocation } from "react-router";
import { useState, useEffect } from "react";
import { Alert, Box, Divider, IconButton, Stack, Tooltip } from "@mui/material";
import { Icon as Iconify } from '@iconify/react';
import ReactQuill from 'react-quill';


import CloseIcon from '@mui/icons-material/Close';


import { FormProvider } from "react-hook-form";
import 'react-quill/dist/quill.snow.css'; // Import Quill styles
import LoadingProgressBar from '../../../components/loading-progressbar';
import { useSchemeStore } from "../schemeStore";



export default function SchemeMail() {

    const location = useLocation();
    const isCopyScheme = location.state?.data?.copyScheme;


    const {
        schemeDetails,
        tabValue,
        prevTabValue,
        updateScheme,
        setMailMessageData,
        addScheme
    } = useSchemeStore();





    const [loading, setLoading] = useState(false); // NOSONAR
    const [content, setContent] = useState(''); // State to store editor content





    const [alertType, setAlertType] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);


    const displayAlert = (type, message, show) => { // NOSONAR
        setAlertType(type);
        setAlertMessage(message);
        setShowAlert(show);
    }
    const hideAlert = () => { // NOSONAR
        setAlertType('');
        setAlertMessage('');
        setShowAlert(false);
    }





    useEffect(() => {
        if (schemeDetails?.MailCirculation?.MailMessage) {
            setContent(schemeDetails.MailCirculation.MailMessage);
        }
    }, [schemeDetails]);





    const handleEditorChange = (value) => {
        setContent(value);
    }

    // Full toolbar configuration for ReactQuill
    const modules = {
        toolbar: [
            // [{ 'font': [] }, { 'size': [] }], // Font and size dropdowns
            [{ 'size': [] }], // Font and size dropdowns
            ['bold', 'italic', 'underline', 'strike'], // Formatting buttons
            [{ 'color': [] }, { 'background': [] }], // Text color and background color
            [{ 'script': 'sub' }, { 'script': 'super' }], // Subscript / superscript
            ['blockquote', 'code-block'], // Blockquote and code block
            [{ 'header': 1 }, { 'header': 2 }], // Headers
            [{ 'list': 'ordered' }, { 'list': 'bullet' }], // Ordered / bullet list
            [{ 'indent': '-1' }, { 'indent': '+1' }], // Indentation
            [{ 'align': [] }], // Text alignment
            // ['link', 'image', 'video'], // Links, images, videos
            ['link'], // Links, images, videos
            ['clean'], // Remove formatting
        ]
    };

    // Formats supported by the editor
    const formats = [
        // 'font', 'size',
        'size',
        'bold', 'italic', 'underline', 'strike',
        'color', 'background',
        'script',
        'blockquote', 'code-block',
        'header',
        'list', 'bullet',
        'indent',
        'align',
        // 'link', 'image', 'video',
        'link',
    ];


    useEffect(() => {
        if (prevTabValue.name === 'Mail Message') {
            formDataSave();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabValue]);

    const formDataSave = async () => {

        let mailMessageData;
        try {

            const payload = schemeDetails;

            payload.FromDate = payload.From_FromDate;
            payload.ToDate = payload.To_ToDate;
            payload.From_FromDate = undefined;
            payload.To_ToDate = undefined;

            payload.MailCirculation = {
                "MailMessage": content
            };

            mailMessageData = {
                "MailMessage": content
            }
               console.log("mailMessagePayload; ", mailMessageData);

            setMailMessageData(mailMessageData);
           

        } catch (error) {
            console.error('Error occured: ', error);

        }

    }



    const saveData = async () => {

        let mailMessageData;
        try {

            const payload = schemeDetails;

            payload.FromDate = payload.From_FromDate;
            payload.ToDate = payload.To_ToDate;
            payload.From_FromDate = undefined;
            payload.To_ToDate = undefined;

            payload.MailCirculation = {
                "MailMessage": content
            };
            
            mailMessageData = {
                "MailMessage": content
            }
               console.log("mailMessagePayload; ", mailMessageData);

            setMailMessageData(mailMessageData);
            try {
                if (isCopyScheme) {
                    const result = await addScheme(); // NOSONAR
                } else {

                    const result = await updateScheme(); // NOSONAR
                }
            } catch (err) {
                // handle error
            }

        } catch (error) {
            console.error('Error occured: ', error);
            
        }
    }


    return (

        <div style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%', // Or '100%' if the parent already has a set height
        }}>
            <FormProvider>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: 1,
                    minHeight: 0, // Important for flex children to grow/shrink
                }}>
                    {/* Scrollable content */}
                    <div style={{
                        flexGrow: 1,
                        minHeight: 0,
                        display: 'flex',         // Make this a flex container
                        flexDirection: 'column', // So ReactQuill can stretch vertically
                    }}>
                        {/* Main Content */}
                        <div style={{
                            flexGrow: 1,
                            minHeight: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            paddingBottom: '5%'
                        }}>
                            <ReactQuill
                                value={content}
                                onChange={handleEditorChange}
                                style={{
                                    flexGrow: 1,
                                    minHeight: 0,
                                    height: '100%',        // This is important!
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}
                                placeholder="Write your message here..."
                                modules={modules}
                                formats={formats}
                            />
                        </div>
                    </div>

                    {/* Divider */}
                    <Divider sx={{ mt: 2 }} />

                    {/* Save button fixed at the bottom */}
                    <Box sx={{ mt: 1 }}>
                        <Stack
                            direction="row"
                            justifyContent="flex-end"
                            spacing={2}
                            alignItems="center"
                            sx={{ padding: '2px' }}
                        >
                            {showAlert && (
                                <Stack sx={{ width: '30%', position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -40%)" }} spacing={2}>
                                    <Alert
                                        severity={alertType}
                                        action={
                                            <IconButton
                                                aria-label="close"
                                                color="inherit"
                                                size="small"
                                                onClick={() => {
                                                    setAlertType('');
                                                    setAlertMessage('');
                                                    setShowAlert(false);
                                                }}
                                            >
                                                <CloseIcon fontSize="inherit" />
                                            </IconButton>
                                        }
                                    >
                                        {alertMessage}
                                    </Alert>
                                </Stack>
                            )}
                            {loading && <LoadingProgressBar />}
                            {schemeDetails?.SchemeLock !== true && (
                                <Tooltip title="Save">
                                    <IconButton type='button' onClick={() => saveData()} sx={{
                                        bgcolor: '#43b5a2',
                                        color: '#fff',
                                        borderRadius: '4px',
                                        height: '30px',
                                        width: '31px',
                                        padding: '4px',
                                    }}>
                                        <Iconify icon="bx:save" />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </Stack>
                    </Box>
                </div>
            </FormProvider>
        </div>



    )
}